import { api } from './api';

export interface NotaEntrada {
  id: number;
  idFornecedor: number;
  fornecedor: string;
  nomeFornecedor?: string;
  dataCompra: string;
  dataCompraString: string;
  dataInclusao: string;
  dataInclusaoString: string;
  valor: number;
  dataEntradaEmEstoque?: string;
  dataEntradaEmEstoqueString?: string;
  produtos?: NotaEntradaProduto[];
}

export interface NotaEntradaProduto {
  id: number;
  idNotaEntrada: number;
  idProduto: number;
  nomeProduto: string;
  referencia: string;
  quantidade: number;
  precoUnitario: number;
  valorTotal: number;
  totalProduto?: number;
}

export interface NotaEntradaRequest {
  idFornecedor: number;
  dataCompra: string;
  dataEntrada: string;
  valor: number;
  produtos: NotaEntradaProdutoCommand[];
}

export interface NotaEntradaProdutoCommand {
  id?: number;
  idNotaEntrada: number;
  idProduto: number;
  nomeProduto: string;
  referencia: string;
  quantidade: number | '';
  precoCompra: string; // Backend espera string
  valorTotal: number;
  CodigoDeBarras?: string[];
  IdSacola?: string[];
}

export const notaEntradaService = {
  // Buscar todas as notas de entrada
  getAll: async (): Promise<NotaEntrada[]> => {
    const response = await api.get<NotaEntrada[]>('/api/NotaEntrada/GetAll');
    return response.data;
  },

  // Buscar nota de entrada por ID
  getById: async (id: number): Promise<NotaEntrada> => {
    const response = await api.get<NotaEntrada>(`/api/NotaEntrada/GetById?id=${id}`);
    return response.data;
  },

  // Salvar nova nota de entrada
  create: async (data: NotaEntradaRequest): Promise<NotaEntrada> => {
    const response = await api.post<NotaEntrada>('/api/NotaEntrada/Inserir', data);
    return response.data;
  },

  // Atualizar nota de entrada
  update: async (id: number, data: Partial<NotaEntradaRequest>): Promise<NotaEntrada> => {
    const response = await api.put<NotaEntrada>(`/api/NotaEntrada/Update?id=${id}`, data);
    return response.data;
  },

  // Excluir nota de entrada
  delete: async (id: number): Promise<void> => {
    await api.delete(`/api/NotaEntrada/Delete?id=${id}`);
  }
};
